/**
 * Mira API Management Service
 * Our API uses a REST based design, leverages the JSON data format, and relies upon HTTPS for transport. We respond with meaningful HTTP response codes and if an error occurs, we include error details in the response body. API Documentation is at sweyainfotech.com/contact
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MiraManagementApiDomainAssetLocationsDtosAssetLocationDto { 
    id?: string;
    packetType?: string | null;
    batteryLevel?: number;
    signalStrength?: number;
    routerAxisX?: number;
    routerAxisY?: number;
    assetAlliesId?: string | null;
    assetTagAlliesId?: string | null;
    assetName?: string | null;
    routerAlliesId?: string | null;
    routerName?: string | null;
    routerLocationName?: string | null;
    lastConnectedRouterLocationName?: string | null;
    floorNo?: number;
    floorHeight?: number;
    floorWidth?: number;
    floorIndoorPlanImageUrl?: string | null;
    floorCanvasResolutionX?: number;
    floorCanvasResolutionY?: number;
    floorIndoorPlanImageResolutionX?: number;
    floorIndoorPlanImageResolutionY?: number;
    floorP?: number;
    lastModifiedOn?: string | null;
    plantCode?: string | null;
}

